<template>
    <div class="hts-layout-default">
        <template v-if="!initialized">
            <div class="w-screen h-screen">
                <div class="hts-loading loading">
                    <div class="hts-loading__dot-fire" />
                </div>
            </div>
        </template>
        <template v-else>
            <layout-navigation
                :menu-items="menuItems"
                :top-menu-items="topMenuItems">
                <router-view />
            </layout-navigation>
        </template>
        <hts-global-backdrop />
    </div>
</template>

<script lang="ts" setup>
import LayoutNavigation from './-default/navigation.vue'
import menuItems from '~/data/menus/trucker/adminCP.json'
import topMenuItems from '~/data/menus/trucker/topMenu.json'

const config = useRuntimeConfig().public
useHead({
  title: config.appName
})
const store = $store()
const initialized = ref(false)
const { colors } = useRuntimeConfig().public
const themeColor = store.theme.getColor
const router = useRouter()
const workspaceId = computed(() => store.auth.workspaceId)
const companyId = computed(() => store.system.getCompanyId)
const companyType = computed(() => store.auth.companyType)
const id = computed(() => router.currentRoute.value.params.id)
const route: any = computed(() => router.currentRoute.value)
const { $event, $dayjs, $formatters, $eventBus, $vehicle, $journey, $trip } = useNuxtApp()
const notipushed = ref<string[]>([])
const setWorkspace = async (id: any) => {
  if (!id) {
    return false
  }
  const workspaces = store.userConfig.workspaces
  const workspace = workspaces.find((w: any) => w._sid === id)

  if (workspace) {
    const { _sid, companyType, timezone, type, cooperatorTypes } = workspace
    store.auth.setWorkspace({ id: _sid, companyType, timezone, type, cooperatorTypes })
    await new Promise((resolve: any) => setTimeout(() => resolve(), 300))
    return true
  }
}
/** Initialize */
onMounted(async () => {
  themeColor !== 'orange' && setThemeColor()
  if (!id.value) {
    return
  }
  if (id.value !== workspaceId.value) {
    console.log('sadfsadfsadf2')
  }

  if (!checkOwner(companyType.value)) {
    return
  }
  await getSystemConfig()
  nextTick(() => {
    initialized.value = true
  })
  useState('initialized', () => true)

  checkRoutePermission((route.value?.name || '').toString(), true)
  notificationListen()
  getNotifications()
  getSystemLocations()
  getGlobalSettings()
  // if (checkPermission('journey_schedule_automation')) {
  //   setInterval(journeyScheduleAlertCheck, 30000)
  // }
  // const companyId: any = store.userConfig.user.company._id
  // if (process.client) {
  //   console.log(`admincp-get-system-data-admin-${companyId}`)
  //   await $event.connect()
  //   // $event.listen(`admincp-get-system-data-admin-${companyId}`, async (data: any) => {
  //   //   console.log('ok getSystemData')
  //   //   console.log('data', data)
  //   //   await getSystemData()
  //   // })

  //   // $event.listen(`company-sync`, (data: any) => {
  //   //   console.log('data', data)
  //   // })
  // }
})

onUnmounted(() => {
  console.log('onUnmounted')
  store.notification.clear()
  const user: any = store.userConfig.user
  const companyId: any = store.userConfig.user.company._id
  initialized.value = false
  $event.unsubscribe('company-user-notification-' + user._id, () => {})
  $event.unsubscribe('company-sync', () => {})
  $event.unsubscribe(`admincp-get-system-data-admin-${companyId}`, () => {})
})

/** Watching */
watch(
  () => companyType.value,
  (val: string | undefined) => {
    checkOwner(val)
  }
)

/** Methods */
const setThemeColor = () => {
  if (process.client && colors[themeColor as keyof typeof colors]) {
    const color = colors[themeColor as keyof typeof colors]
    const r: HTMLElement | null = document.querySelector(':root')
    if (r) {
      r.style.setProperty('--primary-main-50', color['50'])
      r.style.setProperty('--primary-main-100', color['100'])
      r.style.setProperty('--primary-main-200', color['200'])
      r.style.setProperty('--primary-main-300', color['300'])
      r.style.setProperty('--primary-main-400', color['400'])
      r.style.setProperty('--primary-main-500', color['500'])
      r.style.setProperty('--primary-main-600', color['600'])
      r.style.setProperty('--primary-main-700', color['700'])
      r.style.setProperty('--primary-main-800', color['800'])
      r.style.setProperty('--primary-main-900', color['900'])
    }
  }
}

const notificationListen = async () => {
  if (process.client) {
    const user: any = store.userConfig.user
    await $event.connect()
    $event.listen('company-user-notification-' + user._id, (data: any) => {
      if (!notipushed.value.includes(data?.message?._id)) {
        store.notification.unshiftNotification(data?.message || null)
        store.notification.plusUnread(1)
        notipushed.value.push(data)
      }
    })

    $event.listen('company-sync', async ({ message }: any) => {
      if (!message) {
        return
      }

      if (message?.companyId === companyId.value) {
        switch (message?.type) {
        case 'system-data':
          await getSystemData()

          break
        case 'global-settings':
          getGlobalSettings()
          break
        case 'vehicle':
          $vehicle.setGPS(message.info)
          break
        case 'journey':
          $journey.change(message.info)
          break
        case 'trip':
          $trip.change(message.info)
          break
        }
      }
    })
  }
}

const getSystemConfig = async () => {
  try {
    const response = await $api($url.system.getSystemConfig)
    const responseData: any = $lodash.get(response, 'data.value')
    if (responseData?.success) {
      const configData = responseData.data || {}
      const user = configData.user || {}

      const group = configData.group || {}
      store.system.setCompany(user.company)
      store.system.setWorkspaceCompany(configData.workspaceCompany)
      store.system.setWorkspace(user.workspace)
      store.system.setWorkspaceUsers(configData.workspaceUsers)
      store.system.setCompanyUsers(configData.companyUsers)
      store.system.setPrimaryColor(configData.primaryColor)
      store.system.setGroup(user.group)
      store.system.setScheduleSettings(configData.scheduleSettings)
      store.system.timezone = configData.timezone
      store.system.dateFormat = configData.dateFormat
      store.system.timeFormat = configData.timeFormat
      store.system.timezoneText = configData.timezoneText
      store.userConfig.setPage('OWNER')
      store.userConfig.setUser(user)
      store.userConfig.setGroup(group)
      store.userConfig.setAvatar(user.avatar)
      store.userConfig.setLogo(user.company && user.company.logoInfo?.path)
      store.userConfig.setIsDriver(configData.isDriver)
      store.userConfig.workspaces = configData.workspaces || []
      store.userConfig.companyTypes = configData.companyTypes || []
      store.userConfig.isAdmin = configData.isAdmin || false
      store.userConfig.isCompanyAdmin = configData.isCompanyAdmin || false
      store.data.setBusinesses(configData.businesses || [])
      store.data.setVehicleCategories(configData.vehicleCategories || [])
      store.data.setTasks(configData.tasks || [])
      store.data.setDrivers(configData.drivers || [])
      store.data.setTollStationStructure(configData.tollStationStructure)

      useState('group', () => user.group)
    } else {
      router.push({ name: 'errors-access-denied' })
    }
  } catch (e: any) {
    if (process.client && typeof e.message === 'string') {
      $toast().error(e.message)
    }
  }
}

const getSystemLocations = async () => {
  const response = await $api($url.system.getLocations)
  const responseData: any = $lodash.get(response, 'data.value')
  if (responseData?.success) {
    store.library.setLocations(responseData.data)
  }
}

const getSystemData = $lodash.debounce(async () => {
  try {
    const response = await $api($url.system.getSystemData)
    const responseData: any = $lodash.get(response, 'data.value')
    if (responseData.success) {
      const configData = responseData.data || {}

      store.data.setBusinesses(configData.business)
      store.data.setTasks(configData.task)
    }
  } catch (e: any) {
    if (process.client && typeof e.message === 'string') {
      $toast().error(e.message)
    }
  }
}, 200)

const getGlobalSettings = () => {
  const api = $url.settings.getGlobalSettings
  $api(api).then((data) => {
    if (!data) {
      return true
    }
    const responseData: any = data.data.value
    if (responseData.success) {
      store.globalSettings.setGlobalSettings(responseData.data)
    }
  })
}

const getNotifications = () => {
  $api($url.notification.notificationList, {
    body: {
      startRow: 0,
      endRow: 10
    }
  })
    .then((notifications) => {
      const success = $lodash.get(notifications, 'data.value.success')
      if (success) {
        const res: any = $lodash.get(notifications, 'data.value.data')
        const notify = res.notification || []
        const unread = res.unread || 0
        store.notification.setNotifications(notify)
        store.notification.setUnread(unread)
      }
    })
    .catch((e: any) => {
      if (process.client && typeof e.message === 'string') {
        $toast().error(e.message)
      }
    })
}

const checkOwner = (val: string | undefined) => {
  if (val !== undefined && val !== 'OWNER') {
    router.push({
      // name: 'workspace-list'
      name: 'user-search-booking'
    })
    return false
  }
  return true
}

const alertEnable = reactive({
  journeyScheduleAlert: true
})
const nextScheduleStartDatetime = computed(() => {
  return $dayjs().hour(store.system.scheduleSettings.start).minute(0).second(0)
})
const nextScheduleEndDatetime = computed(() => {
  return $dayjs().hour(store.system.scheduleSettings.end).minute(0).second(0)
})
const nextScheduleType = computed(() => {
  const now = $dayjs().minute(0).second(0)
  if (now < nextScheduleStartDatetime.value) {
    return 'start'
  }
  if (now < nextScheduleEndDatetime.value) {
    return 'end'
  }
  return 'next-day'
})
const nextScheduleBegin = computed(() => {
  switch (nextScheduleType.value) {
  case 'start':
    return nextScheduleStartDatetime.value
  case 'end':
    return nextScheduleEndDatetime.value
  case 'next-day':
    return nextScheduleStartDatetime.value.add(1, 'day')
  }
  return null
})
const nextScheduleRangeStart = computed(() => {
  switch (nextScheduleType.value) {
  case 'start':
  case 'next-day':
    return nextScheduleBegin.value?.add(store.system.scheduleSettings.startRange1, 'h')
  case 'end':
    return nextScheduleBegin.value?.add(store.system.scheduleSettings.endRange1, 'h')
  }
  return null
})
const nextScheduleRangeEnd = computed(() => {
  switch (nextScheduleType.value) {
  case 'start':
  case 'next-day':
    return nextScheduleBegin.value?.add(store.system.scheduleSettings.startRange2, 'h')
  case 'end':
    return nextScheduleBegin.value?.add(store.system.scheduleSettings.endRange2, 'h')
  }
  return null
})
const nextScheduleEnd = computed(() => {
  return nextScheduleBegin.value?.add(store.system.scheduleSettings.confirmationTime, 'm')
})
const storeDeadline = computed(() => {
  return store.systemAlert.options.scheduleDeadline
})
const storeScheduleCompleted = computed(() => {
  return store.systemAlert.options.scheduleCompleted
})
const getCurrentScheduleValid = async (): Promise<boolean> => {
  const { data } = await $api($url.journey.schedule.get)
  const temp = (data?.value || {}).data || {}
  const scheduleData = temp.scheduleData || []
  if (!Array.isArray(scheduleData) || !scheduleData.length) {
    return false
  }
  return scheduleData.length > 0
}
const journeyScheduleAlertCheck = () => {
  const now = $dayjs()

  if (nextScheduleBegin.value && nextScheduleEnd.value && now > nextScheduleBegin.value && now < nextScheduleEnd.value) {
    const startTime = $formatters.datetime(nextScheduleRangeStart.value?.format())
    const startEnd = $formatters.datetime(nextScheduleRangeEnd.value?.format())
    const deadline = $formatters.datetime(nextScheduleEnd.value?.format())
    if (deadline === storeDeadline.value && storeScheduleCompleted.value) {
      return
    }
    let content = `<p>Bạn cần thực hiện điều xe chính thức cho các chặng hàng có thời gian khởi hành dự kiến trong khoảng <b>${startTime} - ${startEnd}</b>.</p>`
    content += `<p class=mt-2>Sau <b>${deadline}</b>, nếu không thực hiện thao tác điều xe, danh sách xe được điều dự kiến sẽ đổi trạng thái thành điều chính thức. </p>`
    setTimeout(() => {
      alertEnable.journeyScheduleAlert = true
      store.systemAlert.setAlertVisible(false)
    }, store.system.scheduleSettings.confirmationTime * 60000)
    if (alertEnable.journeyScheduleAlert) {
      $eventBus.emit('global-backdrop-alert-show', {
        content,
        style: {
          backgroundColor: '#f59e0b',
          color: '#FFF'
        },
        closeButtonText: 'Điều xe',
        route: {
          name: 'trucker-id-journey-distributing',
          query: { action: 'open-schedule' }
        },
        action: () => {
          alertEnable.journeyScheduleAlert = false
        }
      })
    }

    store.systemAlert.setAlertVisible(
      true,
      'Bạn cần điều phối chặng hàng trước <b class="px-1 text-yellow-500">' + $formatters.datetime(nextScheduleEnd.value?.format()) + '</b>',
      {
        name: 'trucker-id-journey-distributing',
        query: { action: 'open-schedule' }
      },
      {
        backgroundColor: '#e11d48',
        color: '#FFF'
      },
      {
        scheduleDeadline: deadline,
        scheduleCompleted: false
      }
    )
  }
}
</script>
